const dummyData = [
  {
    description: "Increase customer satisfaction",
    metric: "Customer survey score",
    frequency: "Monthly",
    currentStatus: "85%",
    supportingFile: "survey_results.pdf",
    notes: "Focus on delivery time",
  },
  {
    description: "Reduce defect rate",
    metric: "Defect percentage",
    frequency: "Quarterly",
    currentStatus: "2%",
    supportingFile: "defect_report.xlsx",
    notes: "Implement new QA process",
  },
  {
    description: "Improve employee training",
    metric: "Training hours",
    frequency: "Annually",
    currentStatus: "40 hours",
    supportingFile: "training_schedule.docx",
    notes: "Add advanced modules",
  },
];

export default dummyData;
